import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { selectedCompanyStorage } from '../../storage/company/index';
import { useAppMutation } from '../use-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';

export const useDeleteConversion = () => {
  const { invalidateQuery } = useInvalidateQueries(
    QueryKey.GET_EVENTS,
    QueryKey.GET_SAFES,
    QueryKey.GET_SAFE_CONVERSION,
    QueryKey.GET_EVENT_TRANSACTIONS,
    QueryKey.GET_ISSUED_SHARES,
    QueryKey.GET_SNAPSHOTS,
    QueryKey.GET_SNAPSHOT,
    QueryKey.GET_SAFE_OVERALL_STATUS,
    QueryKey.GET_SAFE_RECAP,
  );

  const companyId = selectedCompanyStorage(({ companyId }) => companyId);
  const { mutate: deleteConversion, isPending } = useAppMutation(
    [QueryKey.DELETE_SAFE_CONVERSION],
    {
      mutationFn: (conversionId: string) =>
        ApiService.delete({
          endpoint: BackendRoute.COMPANIES,
          routePath: [companyId, 'safes-conversion', conversionId],
        }),
      onSuccess: () => {
        invalidateQuery();
      },
    },
  );
  return { deleteConversion, isPending };
};
